import { buildSearchStatus } from '@coveo/atomic-react';
import { useController } from '@lib/hooks/useController';
import { useMemo } from 'react';
import { useEngine } from '../EngineContext';

/**
 * Hook that provides loading state signals for search-v2 components.
 * - isInitialLoad: true until the first search completes (show skeletons)
 * - isLoading: true whenever a search is in progress
 * - hasError: true when the last search request failed
 */
export function useSearchLoading() {
  const eng = useEngine();
  const controller = useMemo(() => buildSearchStatus(eng), [eng]);
  const state = useController(controller);

  return {
    isInitialLoad: !state.firstSearchExecuted,
    isLoading: state.isLoading,
    hasError: state.hasError,
  };
}
